export const defaultMenuFor = (userRole: string) => {
  if (userRole === 'Admin') {
    return [
      { path: '/agent/dashboard', label: 'Dashboard' },
      { path: '/agent/clients/all', label: 'Clients' },
      { path: '/agent/global-map', label: 'Global Map' },
      //{ path: '/agent/companies', label: 'Companies' },  
      { path: '/agent/burnin', label: 'Burn In' },
      { path: '/agent/installations/all', label: 'Installations' },
      { path: '/agent/tech-tools', label: 'Tech Tools' },
      { path: '/agent/mgt-devices/all', label: 'Devices' },
      { path: '/agent/uptime/all', label: 'Uptime' },
      { path: '/agent/onboarding/client/add', label: 'Add Client', hideInMainMenu: true },
      { path: '/admin/add-agent', label: 'Add Agent', hideInMainMenu: true },
      //{ path: '/admin/add-company', label: 'Add Company', hideInMainMenu: true },
      { path: '/reset-password', label: 'Change Password', hideInMainMenu: true },
      { path: '#', label: 'Logout', hideInMainMenu: true },
    ];
  } else if (userRole === 'Technical-Agent') {
    return [
      { path: '/agent/dashboard', label: 'Dashboard' },
      { path: '/agent/clients/all', label: 'Clients' },
      //{ path: '/agent/companies', label: 'Companies' },
      { path: '/agent/burnin', label: 'Burn In' },
      { path: '/agent/installations/all', label: 'Installations' },
      { path: '/agent/tech-tools', label: 'Tech Tools' },
      { path: '/agent/mgt-devices/all', label: 'Devices' },
      { path: '/agent/uptime/all', label: 'Uptime' },
      { path: '/agent/onboarding/client/add', label: 'Add Client', hideInMainMenu: true },
      { path: '/admin/add-agent', label: 'Add Agent', hideInMainMenu: true },
      //{ path: '/admin/add-company', label: 'Add Company', hideInMainMenu: true },
      { path: '/reset-password', label: 'Change Password', hideInMainMenu: true },
      { path: '#', label: 'Logout', hideInMainMenu: true },
    ];
  } else if (userRole === 'Installer') {
    return [
      { path: '/agent/dashboard', label: 'Dashboard' },
      { path: '/agent/installations/all', label: 'Installations' },
      { path: '/agent/tech-tools', label: 'Tech Tools' },
      { path: '/agent/mgt-devices/all', label: 'Devices' },
      { path: '/reset-password', label: 'Change Password', hideInMainMenu: true },
      { path: '#', label: 'Logout', hideInMainMenu: true },
    ];
  } else if (userRole === 'Company-Admin') {
    return [
      { path: '/agent/dashboard', label: 'Dashboard' },
      { path: '/agent/clients/all', label: 'Users' },
      //{ path: '/agent/companies', label: 'Companies' },
      { path: '/agent/uptime/all', label: 'Uptime' },
      { path: '/reset-password', label: 'Change Password', hideInMainMenu: true },
      { path: '#', label: 'Logout', hideInMainMenu: true },
    ];
  } else {
    return [
      { path: '/agent/dashboard', label: 'Dashboard' },
      { path: '/agent/clients/all', label: 'Clients' },
      //{ path: '/agent/onboarding', label: 'Onboarding' },
      { path: '/reset-password', label: 'Change Password', hideInMainMenu: true },
      { path: '#', label: 'Logout', hideInMainMenu: true },
    ];
  };
}

export const clientSortOptions = [
  { path: '', label: 'Latest' },
  { path: '', label: 'Active Alerts' },
  { path: '', label: 'A - Z' },
  { path: '', label: 'Z - A' },
];

export const defaultSortOptions = [
  { path: '', label: 'Latest' },
  { path: '', label: 'A - Z' },
  { path: '', label: 'Z - A' },
];

export const burnInSortOptions = [
  { path: '', label: 'Latest' },
];

export const sortMenu = [
  { path: '#', label: 'Latest' },
  { path: '#', label: 'Active Alerts' },
  { path: '#', label: 'Locked' },
  { path: '#', label: 'Unlocked' },
  { path: '#', label: 'Low Battery' },
  { path: '#', label: 'A - Z' },
  { path: '#', label: 'Z - A' },
];

export const accountMenu = [
  { path: '/agent/onboarding/client/:clientId/add-driver', label: 'Add Vehicle' },
  { path: '/agent/clients/:clientId/account/view', label: 'View Account' },
  // { path: '/account/history', label: 'View Account History' },
  // { path: '/account/delete', label: 'Delete Account' },
];

export const detailsMenu = [
  { path: '/vehicle/edit', label: 'Edit Details' },
  { path: '/vehicle/payment', label: 'Payment History' },
  { path: '/vehicle/delete', label: 'Delete Request' },
];